module.exports = __webpack_public_path__ + "fb29ad0e1dbf3e0eb0f0c2af374424a1.svg";